export default __webpack_public_path__ + "static/media/jonathanwestman.498bb220.jpeg";